import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { apmKeyPayNowKey } from "../../constants/common.c";
import { useFullWidthWalletButton } from "../hooks/useFullWidthWalletButton";
import { usePayNowQr, PayNowQrResult } from "./hooks/usePayNowQr";
import "./style.css";

export type { PayNowQrResult };

type DasPayNowButtonProps = {
  apiData: any;
  slug: string;
  setDasLoader: (v: boolean) => void;
  setAmountPopup: (fn: any) => void;
  onQrGenerated: (qr: PayNowQrResult) => void;
  navigate: any;
};

export const DasPayNowButton = ({
  apiData,
  slug,
  setDasLoader,
  setAmountPopup,
  onQrGenerated,
  navigate,
}: DasPayNowButtonProps) => {
  const { t } = useTranslation();
  const isFullWidthButton = useFullWidthWalletButton(apiData, apmKeyPayNowKey);
  const { requestQr } = usePayNowQr({
    apiData,
    slug,
    setDasLoader,
    setAmountPopup,
    onQrGenerated,
    navigate,
  });

  useEffect(() => {
    localStorage.setItem("slug", slug);
  }, [slug]);

  return (
    <button
      type="button"
      className={
        isFullWidthButton
          ? "paynow-button full-width-button"
          : "paynow-button"
      }
      onClick={requestQr}
    >
      {t("merchant.button.PayNowQR")}
    </button>
  );
};

export default DasPayNowButton;
